@switch (formField.type) {
    @case (DynamicFormFieldTypeEnum.String) {
        <mat-form-field class="w-100">
            <mat-label>{{ formField.label }}</mat-label>
            <input [formControl]="control" type="text" matInput />
            <mat-error>
                <sl-form-field-error-control [control]="control" />
            </mat-error>
        </mat-form-field>
    }
    @case (DynamicFormFieldTypeEnum.Integer) {
        <mat-form-field class="w-100">
            <mat-label>{{ formField.label }}</mat-label>
            <input [formControl]="control" type="number" step="1" matInput />
            <mat-error>
                <sl-form-field-error-control [control]="control" />
            </mat-error>
        </mat-form-field>
    }
    @case (DynamicFormFieldTypeEnum.Decimal) {
        <mat-form-field class="w-100">
            <mat-label>{{ formField.label }}</mat-label>
            <input [formControl]="control" type="number" matInput />
            <mat-error>
                <sl-form-field-error-control [control]="control" />
            </mat-error>
        </mat-form-field>
    }
    @case (DynamicFormFieldTypeEnum.Select) {
        <mat-form-field class="w-100">
            <mat-label>{{ formField.label }}</mat-label>
            <mat-select [formControl]="control" [multiple]="formField.isMultiSelect">
                @for (option of formField.selectOptions ?? []; track option) {
                    <mat-option [value]="option.value">
                        {{ option.label }}
                    </mat-option>
                }
            </mat-select>
            <mat-error>
                <sl-form-field-error-control [control]="control" />
            </mat-error>
        </mat-form-field>
    }
    @case (DynamicFormFieldTypeEnum.Shareholder) {
        <sl-entity-autocomplete
            [formControl]="control"
            [label]="formField.label"
            [isLabelTranslated]="true"
            [type]="EntityTypeEnum.Shareholder"
            [isMultiSelect]="formField.isMultiSelect ?? false" />
    }
    @default {
        <mat-form-field class="w-100">
            <mat-label>{{ formField.label }}</mat-label>
            <input [formControl]="control" type="text" matInput />
            <mat-error>
                <sl-form-field-error-control [control]="control" />
            </mat-error>
        </mat-form-field>
    }
}
